<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>
          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <a href="/">CRCB Control Panel</a> > <span>權限管理</span>
            <h1 class="h3 mb-2 mt-2 text-gray-800">權限管理</h1>
            <Msg :message="message" :is_error="is_error"></Msg>
           
            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <!-- DataTales Example -->
            <div class="card shadow mb-4" v-if="!loading" >
              <div class="card-header py-3">
              <button type="button" class="btn btn-primary" v-on:click="AddUser">新增管理員</button>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  
                  <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th>E-mail</th>
                        <th>姓名</th>
                        <th>帳號狀態</th>
                        <th>功能</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item) in users" :key="item.id">
                        <td><a v-bind:href="'/admin/user/'+ item.id" > {{item.data.email}}</a></td>
                        <td>{{item.data.name}}</td>
                        <td v-if="!item.data.is_disabled" class="text-success">正常</td>
                        <td v-if="item.data.is_disabled" class="text-danger">停權</td>
                        <td>
                          <button type="button" class="btn btn-primary" v-on:click="EditUser(item.id)">編輯</button>
                          <button type="button" class="btn btn-danger" v-on:click="DeleteUser(item.id)">刪除</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

      <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
export default {
  name: 'User',
  data () {
    return {
      users:[],
      loading:true,
      message:'',
      is_error:false
    }
  },
  mounted () {
    this.Get();
  },
  methods: {
    Get(){
        this.users = [];
        var vm = this;
        // 取得列表
        db.collection("admin").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                var data = {"id": doc.id, "data": doc.data()};
                
                this.users.push(data);
            });
            
            this.users.sort( (d1, d2)  => Number(d2.data.is_superuser) - Number(d1.data.is_superuser));
            
            this.loading = false;            
             

            if ($.fn.DataTable.isDataTable('#dataTable')) {
              $('#dataTable').dataTable().fnClearTable();
              $('#dataTable').dataTable().fnDestroy();
            }
            vm.Enabled();
        });
    },
    AddUser() {
      this.$router.push({path: '/admin/user/add'});
    },
    EditUser(id) {
      this.$router.push({path: '/admin/user/' + id });
    },
    DeleteUser(id) {
      if ( confirm("確定要刪除?") ) {

        this.Beforesend();
        db.collection("admin").doc(id).delete()
        .then(() => {
            alert("刪除成功!");
            this.Aftersend();
            this.Get();
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    Enabled(){
      $(document).ready(function() {
              setTimeout(function(){
                $('#dataTable').DataTable({
                  "searching": false,
                  "language": {
                    "processing": "處理中...",
                    "loadingRecords": "載入中...",
                    "lengthMenu": "顯示 _MENU_ 項結果",
                    "zeroRecords": "沒有符合的結果",
                    "info": "顯示第 _START_ 至 _END_ 項結果，共 _TOTAL_ 項",
                    "infoEmpty": "顯示第 0 至 0 項結果，共 0 項",
                    "infoFiltered": "(從 _MAX_ 項結果中過濾)",
                    "infoPostFix": "",
                    "search": "搜尋:",
                    "paginate": {
                        "first": "第一頁",
                        "previous": "上一頁",
                        "next": "下一頁",
                        "last": "最後一頁"
                    },
                    "aria": {
                        "sortAscending": ": 升冪排列",
                        "sortDescending": ": 降冪排列"
                    }
                  }
                });
              }, 200)
              
            });
            
    }
  }
}
</script>
<style scoped>
td {
  border-top:1px solid #e3e6f0 !important;
  border-bottom: 0px;
  border-left: 0px;
  border-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue